import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import api from "../services/api";
import Navbar from "../components/Navbar";
import { useAuth } from "../context/AuthContext";

function EditExam() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();

  const [categories, setCategories] =
    useState([]);

  const [formData, setFormData] =
    useState({
      title: "",
      slug: "",
      description: "",
      price: 0,
      is_free: true,
      file_url: "",
      thumbnail_url: "",
      category_id: ""
    });

  useEffect(() => {

    const loadData = async () => {

      try {

        const categoriesResponse =
          await api.get("/categories");

        setCategories(
          categoriesResponse.data
        );

        const examResponse =
          await api.get(`/exams/${id}`);

        const exam =
          examResponse.data;

        setFormData({
          title: exam.title || "",
          slug: exam.slug || "",
          description:
            exam.description || "",
          price: exam.price || 0,
          is_free:
            exam.is_free || false,
          file_url:
            exam.file_url || "",
          thumbnail_url:
            exam.thumbnail_url || "",
          category_id:
            exam.category?.id || ""
        });

      } catch (error) {

        console.error(error);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load exam"
        });

      }

    };

    loadData();

  }, [id]);

  const handleChange = (e) => {

    const {
      name,
      value,
      checked,
      type
    } = e.target;

    setFormData({
      ...formData,
      [name]:
        type === "checkbox"
          ? checked
          : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      await api.patch(
        `/exams/${id}`,
        {
          ...formData,
          price: Number(
            formData.price
          ),
          category_id: Number(
            formData.category_id
          )
        },
        {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      await Swal.fire({
        icon: "success",
        title: "Success",
        text:
          "Exam updated successfully!",
        timer: 2000,
        showConfirmButton: false
      });

      navigate("/exams/manage");

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text:
          error.response?.data
            ?.message ||
          "Failed to update exam"
      });

    }
  };

  return (
    <div>
      <Navbar />

      <div className="form-container">

        <h1>Edit Exam</h1>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            name="title"
            placeholder="Title"
            value={formData.title}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="slug"
            placeholder="Slug"
            value={formData.slug}
            onChange={handleChange}
            required
          />

          <textarea
            name="description"
            placeholder="Description"
            value={formData.description}
            onChange={handleChange}
          />

          <input
            type="number"
            name="price"
            placeholder="Price"
            value={formData.price}
            onChange={handleChange}
          />

          <input
            type="text"
            name="file_url"
            placeholder="File URL"
            value={formData.file_url}
            onChange={handleChange}
          />

          <input
            type="text"
            name="thumbnail_url"
            placeholder="Thumbnail URL"
            value={formData.thumbnail_url}
            onChange={handleChange}
          />

          <select
            name="category_id"
            value={formData.category_id}
            onChange={handleChange}
            required
          >
            <option value="">
              Select Category
            </option>

            {categories.map(
              (category) => (
                <option
                  key={category.id}
                  value={category.id}
                >
                  {category.name}
                </option>
              )
            )}
          </select>

          <label>
            Free Exam{" "}
            <input
              type="checkbox"
              name="is_free"
              checked={
                formData.is_free
              }
              onChange={
                handleChange
              }
            />
          </label>

          <button type="submit">
            Update Exam
          </button>

        </form>

      </div>
    </div>
  );
}

export default EditExam;